import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, AlertCircle } from 'lucide-react';
export function ForWho() {
  return <Section dark data-id="element-59">
      <h2 className="text-3xl md:text-4xl font-serif text-center text-[#2D2A26] mb-12" data-id="element-60">
        ¿Es para ti?
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-61">
        {/* Is For You */}
        <div className="bg-white p-8 rounded-sm shadow-sm border-t-4 border-[#C4A35A]" data-id="element-62">
          <h3 className="text-xl font-serif font-bold text-[#2D2A26] mb-6 flex items-center gap-2" data-id="element-63">
            <CheckCircle2 className="text-[#C4A35A]" data-id="element-64" />
            Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-65">
            {['Se aman, pero el tema de la intimidad se volvió tenso', 'Uno quiere más y el otro se cierra', 'Quieren un método privado, claro y repetible'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-66">
                <span className="text-[#C4A35A] mt-1" data-id="element-67">•</span>
                {item}
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-stone-100 p-8 rounded-sm border-t-4 border-stone-400" data-id="element-68">
          <h3 className="text-xl font-serif font-bold text-stone-600 mb-6 flex items-center gap-2" data-id="element-69">
            <AlertCircle className="text-stone-500" data-id="element-70" />
            No es para ti si:
          </h3>
          <ul className="space-y-4 mb-6" data-id="element-71">
            {['Hay coerción, abuso o miedo en casa', 'Hay infidelidad activa sin acuerdos', 'El consumo problemático domina la dinámica'].map((item, i) => <li key={i} className="flex items-start gap-3 text-stone-600" data-id="element-72">
                <span className="text-stone-400 mt-1" data-id="element-73">•</span>
                {item}
              </li>)}
          </ul>
          <p className="text-sm text-stone-500 italic" data-id="element-74">
            (Ahí lo primero es seguridad y ayuda profesional)
          </p>
        </div>
      </div>
    </Section>;
}